import { render } from "./ChangeInAppHistory.vue?vue&type=template&id=c6b7082a&scoped=true"
import script from "./ChangeInAppHistory.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ChangeInAppHistory.vue?vue&type=script&charset=utf-8&lang=js"

import "./ChangeInAppHistory.vue?vue&type=style&index=0&id=c6b7082a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6b7082a"]])

export default __exports__